// import '@babel/polyfill';
import { setLanguage, getLanguage, i18n, changeLanguage, langReload, getLangList, saveLangKey } from './changeLangs';
import timezone from './timezone';
import Api from './api/index';
import { setState } from './store';
var version = '';
if (typeof "2.2.26" === 'string') {
  // eslint-disable-next-line no-undef
  version = "2.2.26";
}
// console.log(`%c[yxt-i18n] version ${version}`, 'color: green;')

// Note:: 因为用户的域名是随机的，用hostname做判断 有概率会命中学习平台的用户域名
// const is123Platform = location.hostname.split('.').shift().match(/^123/)

// 国际化时区功能初始化, run one time
timezone.init();

/**
 * node项目需要use yxt-i18n 用于设置环境初始值
 * 示例: Vue.use(i18n, { browserLang: initData.language });
 * @param {*} Vue
 * @param {*} configs
 */
var install = function install(Vue, configs) {
  if (configs === void 0) {
    configs = {};
  }
  setState(configs);
};
export { setLanguage, getLanguage, i18n, changeLanguage, langReload, getLangList, saveLangKey } from './changeLangs';
export { version, timezone, Api };
export default {
  install: install,
  version: version,
  timezone: timezone,
  Api: Api,
  setLanguage: setLanguage,
  getLanguage: getLanguage,
  i18n: i18n,
  changeLanguage: changeLanguage,
  langReload: langReload,
  getLangList: getLangList,
  saveLangKey: saveLangKey
};